import { render, staticRenderFns } from "./AiTriageDomainUrlsPanel.vue?vue&type=template&id=e37ae83e&scoped=true&"
import script from "./AiTriageDomainUrlsPanel.vue?vue&type=script&lang=js&"
export * from "./AiTriageDomainUrlsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AiTriageDomainUrlsPanel.vue?vue&type=style&index=0&id=e37ae83e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37ae83e",
  null
  
)

export default component.exports